const AddOnRoot = 'add-ons';

export const addOnsPaths = {
  root: AddOnRoot,
};
